/**
 * PhysiologicalWaveformEngine — public API
 *
 * Uso típico:
 *   import { resolveSignalConfig, sampleECG, samplePleth, sampleRespiration, WaveformCanvas } from '../waveforms';
 *
 *   const cfg = useMemo(() => {
 *     const c = resolveSignalConfig(vitals, patientState);
 *     c._vitals = vitals;  // referencia para artefactos
 *     return c;
 *   }, [vitals, patientState]);
 *
 *   <WaveformCanvas sampler={(t) => sampleECG(t, cfg)} label="ECG II" color="#22c55e" />
 *   <WaveformCanvas sampler={(t) => samplePleth(t, cfg)} label="Pleth" color="#06b6d4" />
 *   <WaveformCanvas sampler={(t) => sampleRespiration(t, cfg)} label="Resp" color="#eab308" />
 */
export {
  resolveSignalConfig,
  resolveRhythm,
  lastQrsTime,
  beatPhase,
  PULSE_TRANSIT_DELAY_MS,
  PULSELESS_RHYTHMS,
  FLATLINE_RHYTHMS,
  CHAOTIC_RHYTHMS,
} from './engine';

export { sampleECG } from './ecgGenerator';
export { samplePleth } from './plethGenerator';
export { sampleRespiration, RESPIRATORY_PATTERNS } from './respirationGenerator';
export { samplePressure } from './pressureGenerator';
export {
  resolveNoiseProfile,
  sampleArtifact,
  SIGNAL_QUALITY_STATES,
  ARTIFACT_TYPES,
} from './artifacts';
export { WaveformCanvas } from './WaveformCanvas';

// Etiquetas de ritmo (compat con /components/ecg/ecgGenerator.js)
export const FALLBACK_RHYTHM_LABELS = {
  sinusal: 'Ritmo sinusal',
  taquicardia_sinusal: 'Taquicardia sinusal',
  bradicardia_sinusal: 'Bradicardia sinusal',
  tsv: 'Taquicardia supraventricular',
  taquicardia_regular_angosto: 'Taquicardia regular de complejo angosto',
  taquicardia_irregular_angosto: 'Taquicardia irregular de complejo angosto',
  fibrilacion_auricular: 'Fibrilación auricular',
  flutter_auricular: 'Flutter auricular',
  taquicardia_ventricular: 'Taquicardia ventricular',
  fibrilacion_ventricular: 'Fibrilación ventricular',
  asistolia: 'Asistolia',
  aesp: 'Actividad eléctrica sin pulso',
  bloqueo_av_1: 'Bloqueo AV 1er grado',
  bloqueo_av_2_mobitz1: 'Bloqueo AV 2º grado Mobitz I',
  bloqueo_av_2_mobitz2: 'Bloqueo AV 2º grado Mobitz II',
  bloqueo_av_completo: 'Bloqueo AV completo',
  otro: 'Otro',
};
